import { Auth, signOut } from '@firebase/auth';

// Plain (non-React) access to the Firebase Auth instance Firebase.ts constructs, mirroring
// msalInstance.ts's own PublicClientApplication accessor (same rationale: code outside the
// component tree -- here, a Playwright test running page.evaluate() in the page's global JS
// context -- can't use useFirebaseContext() and can't `import` app modules either). Added for
// specs/001-msal-login tasks.md T064 (SessionContinuityIT.kt Scenario B): that regression test
// needs to invalidate only the *Firebase* side of an already-authenticated session, leaving
// MSAL's own sessionStorage cache untouched, and there was previously no way to reach the
// Firebase Auth instance from outside React at all.
let instance: Auth | undefined;

export function setFirebaseAuthInstance(auth: Auth) {
    instance = auth;
}

export function getFirebaseAuthInstance(): Auth | undefined {
    return instance;
}

// Test-only hook (see comment above). Exposes a ready-to-call signOut() rather than just the Auth
// instance, since the injected script can't `import { signOut } from 'firebase/auth'` itself.
declare global {
    interface Window {
        __firebaseTestHelpers?: {
            signOut: () => Promise<void>;
        };
    }
}
window.__firebaseTestHelpers = {
    signOut: () => {
        const auth = getFirebaseAuthInstance();
        if (auth === undefined) {
            return Promise.reject(new Error('Firebase auth instance not initialized yet'));
        }
        return signOut(auth);
    },
};
